<ng-container [formGroup]="form">

    <div class="row mt-3 pb-3 border-bottom">
        <div class="col-md-5">
            <label class="control-label question-label" [attr.for]="question.key" [innerHtml]="question.label"></label>
            <span *ngIf="!isValid()" class="text-danger">
                Required
            </span>
        </div>
        <div class="col-md-7">
            <ng-container [ngSwitch]="question.controlType">
                <input *ngSwitchCase="'input'" [formControlName]="question.id" class="form-control" [type]="question.type" [readonly]="question.readonly">

                <select *ngSwitchCase="'dropdown'" [formControlName]="question.id" class="form-control" [attr.disabled]="question.readonly ? '' : null">
                    <option *ngFor="let opt of question.options" [value]="opt.key">{{opt.value}}</option>
                </select>

                <input *ngSwitchCase="'checkbox'" type="checkbox" [formControlName]="question.id" class="form-control" appToggle [isDisabled]="question.readonly" />

                <ng-container *ngSwitchCase="'radiobutton'">
                    <div *ngFor="let opt of question.options; let i = index" class="radio-custom">
                        <input type="radio" [attr.name]="question.key" [formControlName]="question.id" [value]="opt.key" [readonly]="question.readonly" [attr.disabled]="question.readonly ? '' : null">
                        <label [attr.for]="opt.key">{{opt.value}}</label>
                    </div>
                </ng-container>

                <textarea *ngSwitchCase="'textbox'" [formControlName]="question.id" class="form-control" rows="5" [readonly]="question.readonly"></textarea>
            </ng-container>
        </div>
    </div>
    <div class="question-divider"></div>

</ng-container>
